// extracted by mini-css-extract-plugin
module.exports = {"hidden":"gameWarning_hidden__Y_kXB","textEmphasis":"gameWarning_textEmphasis__PCPwE","warningWrap":"gameWarning_warningWrap__wUTiQ"};